import { ApiResponse } from '../types/api';

export const AUTH_REQUIRED_EVENT = 'craftcloud-auth-required';
export const AUTH_REQUIRED_MESSAGE = '请先登录以解锁更多功能';

export interface AuthRequiredEventDetail {
  message?: string;
  showToast?: boolean;
  returnTo?: string;
  reason?: 'route-guard' | 'api-unauthorized' | 'follow-action';
}

export const dispatchAuthRequired = (detail: AuthRequiredEventDetail = {}) => {
  if (typeof window === 'undefined') {
    return;
  }

  window.dispatchEvent(new CustomEvent<AuthRequiredEventDetail>(AUTH_REQUIRED_EVENT, {
    detail: {
      message: AUTH_REQUIRED_MESSAGE,
      showToast: true,
      ...detail
    }
  }));
};

export const isAuthRequiredResponse = <T>(response?: ApiResponse<T> | null): boolean => {
  return Boolean(response?.statusCode === 401 || response?.error === AUTH_REQUIRED_MESSAGE);
};
